import React, { useState, useEffect } from 'react';
import './index.css';

const FestiveTestimonials = ({ config }) => {
  const [active, setActive] = useState(0);
  const testimonials = Array.isArray(config.testimonials?.items) ? config.testimonials.items : [];

  useEffect(() => {
    if (testimonials.length === 0) return;
    const timer = setInterval(() => {
      setActive(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="fs-testimonials">
      <div className="fs-testimonials__deco-1" />
      <div className="fs-testimonials__deco-2" />
      <div className="container">
        <div className="fs-testimonials__header text-center">
          <span className="fs-testimonials__kicker">{config.testimonials?.sub_heading}</span>
          <h2 className="fs-testimonials__title">{config.testimonials?.heading || 'Sweet Words from Sweet People'}</h2>
        </div>

        <div className="fs-testimonials__carousel">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className={`fs-testimonials__card ${active === idx ? 'fs-testimonials__card--active' : ''}`}
            >
              <div className="fs-testimonials__quote-mark">"</div>
              <p className="fs-testimonials__text">{item.text || item.description}</p>
              <div className="fs-testimonials__stars">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <span key={i} className="fs-testimonials__star">★</span>
                ))}
              </div>
              <div className="fs-testimonials__author">
                <div className="fs-testimonials__avatar">
                  {item.name?.charAt(0) || 'U'}
                </div>
                <div>
                  <div className="fs-testimonials__name">{item.name}</div>
                  <div className="fs-testimonials__location">{item.location || item.designation}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="fs-testimonials__dots">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              className={`fs-testimonials__dot ${active === idx ? 'active' : ''}`}
              onClick={() => setActive(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const CafeTestimonials = ({ config }) => {
  const [active, setActive] = useState(0);
  const testimonials = Array.isArray(config.testimonials?.items) ? config.testimonials.items : [];

  useEffect(() => {
    if (testimonials.length === 0) return;
    const timer = setInterval(() => {
      setActive(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="cafe-testimonials">
      <div className="cafe-testimonials__bg-pattern" />
      <div className="container">
        <div className="cafe-testimonials__header text-center">
          <span className="cafe-testimonials__kicker">{config.testimonials?.sub_heading}</span>
          <h2 className="cafe-testimonials__title">{config.testimonials?.heading || 'Loved by Coffee Enthusiasts'}</h2>
        </div>

        <div className="cafe-testimonials__carousel">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className={`cafe-testimonials__card ${active === idx ? 'cafe-testimonials__card--active' : ''}`}
            >
              <div className="cafe-testimonials__quote-mark">"</div>
              <p className="cafe-testimonials__text">{item.text || item.description}</p>
              <div className="cafe-testimonials__stars">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <span key={i} className="cafe-testimonials__star">★</span>
                ))}
              </div>
              <div className="cafe-testimonials__author">
                <div className="cafe-testimonials__avatar">
                  {item.name?.charAt(0) || 'U'}
                </div>
                <div>
                  <div className="cafe-testimonials__name">{item.name}</div>
                  <div className="cafe-testimonials__location">{item.location || item.designation}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="cafe-testimonials__dots">
          {testimonials.map((_, idx) => (
            <button
              key={idx}
              className={`cafe-testimonials__dot ${active === idx ? 'active' : ''}`}
              onClick={() => setActive(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const ModernTestimonials = ({ config }) => {
  const testimonials = Array.isArray(config.testimonials?.items) ? config.testimonials.items : [];
  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="modern-testimonials">
      <div className="modern-testimonials__deco-1" />
      <div className="modern-testimonials__deco-2" />
      <div className="container">
        <div className="modern-testimonials__header">
          <h2 className="modern-testimonials__title">{config.testimonials?.heading}</h2>
          <span className="modern-testimonials__kicker">{config.testimonials?.sub_heading}</span>

          <div className="modern-testimonials__title-line" />
        </div>
        <div className="modern-testimonials__grid">
          {testimonials.map((item, idx) => (
            <div key={idx} className="modern-testimonials__card">
              <div className="modern-testimonials__quote-icon">"</div>
              <p className="modern-testimonials__text">{item.text || item.description}</p>
              <div className="modern-testimonials__stars">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <span key={i} className="modern-testimonials__star">★</span>
                ))}
              </div>
              <div className="modern-testimonials__author">
                <div className="modern-testimonials__avatar">
                  {item.name?.charAt(0) || 'U'}
                </div>
                <div className="modern-testimonials__author-info">
                  <strong className="modern-testimonials__name">{item.name}</strong>
                  <span className="modern-testimonials__location">{item.location || item.designation}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// ═══════════════════════════════════════════════════════════════════
// TEMPLATE 16 — ARISA COLLECTION — "Loved by Our Customers"
// Clean static 3-up grid on desktop, single column on mobile.
// ═══════════════════════════════════════════════════════════════════
const SweetStoreTestimonials = ({ config }) => {
  const testimonials = Array.isArray(config.testimonials?.items) ? config.testimonials.items : [];
  if (testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="t16-reviews">
      <div className="t16-reviews__container">
        <div className="t16-reviews__header">
          <span className="t16-reviews__kicker">{config.testimonials?.sub_heading || 'Real Feedback'}</span>
          <h2 className="t16-reviews__title">{config.testimonials?.heading || 'Loved by Our Customers'}</h2>
        </div>

        <div className="t16-reviews__grid">
          {testimonials.slice(0, 6).map((item, idx) => (
            <div key={idx} className="t16-reviews__card">
              <div className="t16-reviews__stars">
                {[...Array(item.rating || 5)].map((_, i) => (
                  <span key={i} className="t16-reviews__star">★</span>
                ))}
              </div>
              <p className="t16-reviews__text">"{item.text || item.description}"</p>
              <div className="t16-reviews__author">
                <span className={`t16-reviews__avatar t16-reviews__avatar--${idx % 4}`}>
                  {item.name?.charAt(0) || 'U'}
                </span>
                <div>
                  <div className="t16-reviews__name">{item.name}</div>
                  {(item.location || item.designation) && (
                    <div className="t16-reviews__location">{item.location || item.designation}</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TestimonialSection = (props) => {
  const type = (props.config.templateType || 'template1').toLowerCase().replace(/-/g, '_');

  switch (type) {
    case 'template9':
    case 'template10':
    case 'festive_sweets':
      return <FestiveTestimonials {...props} />;
    case 'template14':
    case 'cafe_premium':
      return <CafeTestimonials {...props} />;
    case 'template15':
    case 'dry_fruits':
      return <ModernTestimonials {...props} />;
    case 'template16':
    case 'arisa_collection':
      return <SweetStoreTestimonials {...props} />;
    default:
      return <ModernTestimonials {...props} />;
  }
};

export default TestimonialSection;
